import { render, staticRenderFns } from "./ProjectDetailModal.vue?vue&type=template&id=64735c50"
import script from "./ProjectDetailModal.vue?vue&type=script&lang=js"
export * from "./ProjectDetailModal.vue?vue&type=script&lang=js"
import style0 from "./ProjectDetailModal.vue?vue&type=style&index=0&id=64735c50&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports